import { render, staticRenderFns } from "./maintainOrders-UploaderImage-vant.vue?vue&type=template&id=4cb2a219&scoped=true&"
import script from "./maintainOrders-UploaderImage-vant.vue?vue&type=script&lang=js&"
export * from "./maintainOrders-UploaderImage-vant.vue?vue&type=script&lang=js&"
import style0 from "./maintainOrders-UploaderImage-vant.vue?vue&type=style&index=0&id=4cb2a219&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2a219",
  null
  
)

export default component.exports